var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealEstate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.314 1.345a1.5 1.5 0 00-2.121 0l-9.97 9.969a.75.75 0 101.061 1.062l9.97-9.97 9.968 9.97a.75.75 0 001.062-1.062l-3.53-3.53v-4.94a.75.75 0 00-.75-.75h-1.5a.75.75 0 00-.75.75v1.94l-3.44-3.44z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.253 4.034l7.068 7.068a6.75 6.75 0 00-5.93 10.493H4.502a2.25 2.25 0 01-2.25-2.25v-6.31l9-9z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.003 23.095a5.25 5.25 0 100-10.5 5.25 5.25 0 000 10.5zm2.519-6.74l-2.003 3.34a1.125 1.125 0 01-1.76.215l-1.162-1.16a.75.75 0 011.062-1.06l.82.82 1.756-2.926a.75.75 0 111.287.771z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealEstate);
export default __webpack_public_path__ + "static/media/realEstate.4f9cff776232821f71f940e4222b6237.svg";
export { ForwardRef as ReactComponent };